module.exports = __webpack_public_path__ + "static/12-96cde996dbb2dc887b6235ebdf676485.jpg";